/* 🤖 this file was generated by script */
export const wiconArrowNarrowUpRight = {
  name: 'arrow_narrow_up_right',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6m0 0h-8m8 0v8"/></svg>`,
};
